let $api: { (message: string, params?: { [key: string]: any }): string };

$api = (service: string, params?: { [key: string]: any }): string => {
  const services: { [service: string]: any } = {
    selected_services: "selected-services",
    get_all_services: "services",
    get_service: "/getService/{service_id}",
    get_campaign: "/get-campaign",
    get_most_seller: "/most-sels-product",
    get_product_details: "/productDetail/{products_id}",
    get_phone_prefix: "/get-phone-prefix",
    get_all_blogs: "/blogs",
    get_outlet_heroes:'/outlet-heroes/web',
    get_blog_by_id: "/blogs/{blog_id}",
    post_login: "/login",
    post_logout: "/logout",
    get_all_videos: "/videos",
    get_adress: "/branches",
    get_vacancies: "/vacancy",
    get_vacancies_Detail: "/vacancy./{id}",
    create_vacancy: "/vacancy/{id}",
    show_product: "partner/products/{product_id}",
    partner_similar_products: "partner/products/similar/{product_id}",
    partner_products: "partner/products",
    partner_popular: "partner/popular",
    search_by_image: "partner/products/search/by-image",
    // get_all_partners: "/partners", // Disabled: not needed
    basket: "/basket",
    remove_basket: "basket/{id}",
    total_basket: "basket/total",
    favorites: "/wishlist",
    remove_favorites: "/wishlist/{id}",
    // get_offer_week: "/weekly-picks", // Disabled: returns 404 Not Found from backend
    last_view_products: "/mehsullar/reliated-products",
    get_profile_data: "/profile",
    update_profile_data: "/edit-user-profile",
    show_campaign: "show-campaign/{id}",
    post_register: "/register",
    post_otp: "/verify-otp",
    get_forget_password: "/forget-password",
    edit_profile_info: "/edit-user-profile",
    get_header_categories: "/header-product-categories",
    post_contact: "/feedback",
    get_filials: "/branches",
    get_about: "/about",
    get_search_product: "/search",
    translations: "/translation",
    post_changepasword: "/changePassword",
    post_repair: "/apply-repair-service",
    filter_items_id: "/get-filter-items/{id}",
    filter_data: "/filter-data",
    post_order: "/accessory-order",
    get_order_category: "/order-category",
    get_order: "/orders",
    get_order_statuses: "/orders/statuses",
    // get_header_services: "/getHeaderService", // Disabled: not needed
    get_order_services: "orders/service-order",
    create_order: "/orders",
    get_order_accessory: "/orders/accessory-order",
    cancel_order: "/orders/cancel-order/{id}",
    cancel_service_order: "/orders/cancel-service-order/{id}",
    cancel_accessory_order: "/orders/cancel-accessory-order/{id}",
    get_news: "/news",
    get_news_id: "/news-show/{slug}",
    get_officialServices: "/official-services",
    get_home_hero: "/home-hero",
    get_home_hero_features: "/home-hero-features",
    get_ServicesBrands: "/order-brands",
    social_accounts: "/social-accounts",
    post_assembling: "/apply-assembling-service",
    get_languages: "/language",
    privacy_policy: "/privacy-policy",
    warranty_terms: "/warranty-terms",
    pages: "/page/{id}",
    chatbot_template: "/chat-bot",
    chatbot_template_id: "/chat-bot/{id}",
    post_user_data: "/live-chat/start-chat",
    get_messages: "/live-chat/my-messages",
    send_message: "/live-chat/{id}/message",
    subscribe: "/subscribe",
    post_quick_order: "/quick-order",
    // popup: "/popup", // Disabled: not needed
    delivery_branches_cities: "/delivery-branches/cities",
    delivery_branches: "/delivery-branches",
  };
  if (typeof services[service] === "string") {
    services[service] = { path: String(services[service]) };
  }

  let url = services[service].path;
  if (params) {
    let query_params: { [key: string]: any } = {};
    let has_query_params = false;

    const resolvedParams: { [key: string]: any } = { ...params };
    if (resolvedParams.id !== undefined && resolvedParams.product_id === undefined && url.includes("{product_id}")) {
      resolvedParams.product_id = resolvedParams.id;
      delete resolvedParams.id;
    } else if (resolvedParams.product_id !== undefined && resolvedParams.id === undefined && url.includes("{id}")) {
      resolvedParams.id = resolvedParams.product_id;
      delete resolvedParams.product_id;
    }

    for (const [key, value] of Object.entries(resolvedParams)) {
      let replaced = false;
      url = url.replaceAll("{" + key + "}", () => {
        replaced = true;
        return value;
      });
      if (!replaced) {
        has_query_params = true;
        query_params[key] = value;
      }
    }

    if (has_query_params) {
      let param = new URLSearchParams(query_params);
      url += "?" + param.toString();
    }
  }
  return url;
};

export { $api };
